import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardProps,
} from '@chakra-ui/react';

interface CardTabProps extends Omit<CardProps, '_after' | '_before'> {
  'data-testid'?: string;
  isSelected: boolean;
  header?: React.ReactNode;
  body: React.ReactNode;
  footer?: React.ReactNode;
  selectedBorderColor?: string;
  onClick: () => void;
}
export const CardTab = ({
  'data-testid': dataTestId,
  isSelected,
  header,
  body,
  footer,
  onClick,
  selectedBorderColor = 'cyan.500',
  ...props
}: CardTabProps) => {
  return (
    <Card
      _after={
        isSelected
          ? {
              content: '""',
              position: 'absolute',
              bottom: '-27px',
              right: 'calc(50% - 14px)',
              borderWidth: '14px',
              borderStyle: 'solid',
              borderTopColor: 'opaque.indigo_800_whiteAlpha_100',
              borderLeftColor: 'transparent',
              borderRightColor: 'transparent',
              borderBottomColor: 'transparent',
              zIndex: 3,
            }
          : undefined
      }
      _before={
        isSelected
          ? {
              content: '""',
              position: 'absolute',
              bottom: '-30px',
              right: 'calc(50% - 15px)',
              borderWidth: '15px',
              borderStyle: 'solid',
              borderTopColor: selectedBorderColor,
              borderLeftColor: 'transparent',
              borderRightColor: 'transparent',
              borderBottomColor: 'transparent',
              zIndex: 2,
            }
          : undefined
      }
      borderColor={isSelected ? selectedBorderColor : undefined}
      cursor="pointer"
      data-testid={dataTestId}
      flexGrow={1}
      width="300px"
      onClick={onClick}
      {...props}
    >
      {header && <CardHeader>{header}</CardHeader>}
      {body && <CardBody>{body}</CardBody>}
      {footer && <CardFooter>{footer}</CardFooter>}
    </Card>
  );
};
